import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'lib-session-expired-modal',
    templateUrl: './session-expired-modal.component.html',
    styleUrls: ['./session-expired-modal.component.scss'],
    standalone: false,
})
export class SessionExpiredModalComponent implements OnInit {
    redirect: boolean;

    constructor(private dialog: MatDialog) {}

    startRedirect: (...args: any[]) => void;

    closeModal = () => {
        this.dialog.closeAll();
        this.startRedirect();
    };

    ngOnInit() {}
}
